import SectionLabel from '@/pages/home/components/SectionLabel';
import { tagWall } from '@/mocks/homeData';

export default function TagWall() {
  return (
    <section id="tags" className="border-b border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionLabel
            index="02"
            kicker="TAGS · 话题墙"
            title="这一周大家都在追的话题"
            desc="话题墙按整理次数排序，热度高的会排在最前面，点进去就是对应的专题列表。"
          />
          <p className="shrink-0 text-sm text-foreground-500">共 14 个话题 · 每周更新</p>
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          {tagWall.map((tag) => (
            <a
              key={tag.label}
              href="#topics"
              className={
                tag.hot
                  ? 'group flex items-center gap-2 rounded-full border border-primary-200 bg-primary-100 px-4 py-2 text-sm text-primary-700 transition-colors hover:bg-primary-200'
                  : 'group flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-700'
              }
            >
              <span className={tag.hot ? 'flex h-3.5 w-3.5 items-center justify-center' : 'flex h-3.5 w-3.5 items-center justify-center text-foreground-400'}>
                <i className={tag.hot ? 'ri-fire-line' : 'ri-price-tag-3-line'} />
              </span>
              {tag.label}
              <span className={tag.hot ? 'text-xs text-primary-600' : 'text-xs text-foreground-400'}>{tag.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}